<template>
  <div class="second-Bar">
    <router-link
      :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
      v-for="(item, index) in list"
      :key="item.id"
      class="card"
      :style="`grid-area: card-${index + 1}`"
    >
      <div class="image-block">
        <span class="category">{{ item.sub_category.name }}</span>
        <ImageContainer
          :src="item.image.medium"
          :alt="item.title"
          :thumb="item.image.thumbnail"
          class="image"
        />
      </div>
      <div class="about">
        <h1 class="text">
          {{ item.title }}
        </h1>
        <h2 class="time">
          {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
        </h2>
      </div>
    </router-link>
  </div>
</template>
<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "SecondBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.second-Bar {
  margin: 2rem 0;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  grid-template-rows: auto auto;
  grid-template-areas:
    "card-1 card-2 card-3 card-4"
    "card-1 card-5 card-6 card-7";
  grid-column-gap: 4em;
  grid-row-gap: 4em;
  position: relative;
  width: 90%;
  .card {
    position: relative;
    display: flex;
    flex-direction: column;
    .image-block {
      position: relative;
      width: 100%;
      .image {
        position: relative;
        width: 100%;
        padding-bottom: 66%;
      }
      .category {
        position: absolute;
        top: 0;
        left: 0;
        background-color: var(--secondary-font-color);
        padding: 0.1rem 0.4rem;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 2.5em;
        line-height: 1.4;
        color: var(--category-color);
        z-index: 1;
        text-transform: capitalize;
      }
    }
    .about {
      position: relative;
      padding-top: 1%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 2.5em;
      font-style: normal;
      .text {
        --snup: 3;
        display: -webkit-box;
        -webkit-line-clamp: var(--snup);
        -webkit-box-orient: vertical;
        overflow: hidden;
        position: relative;
        font-family: Roboto;
        font-weight: 500;
        line-height: 1.4;
        color: var(--primary-font-color);
        text-transform: capitalize;
      }
      .time {
        position: relative;
        font-family: Open Sans;
        font-weight: 300;
        line-height: 1;
        color: var(--date-color);
        padding-top: 0.6rem;
        opacity: 0.6;
      }
    }

    &:nth-child(1) {
      align-self: center;
      .about {
        text-align: center;
        .text {
          --snup: 4;
        }
      }
    }
  }
}
@media screen and (max-width: 2900px) {
  .second-Bar {
    width: 90%;
    .card {
      .image-block {
        .category {
          font-size: 1.3em;
        }
      }
      .about {
        font-size: 1.3em;
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .second-Bar {
    width: var(--main-wrapper-width);
    .card {
      .image-block {
        .category {
          font-size: 1em;
        }
      }
      .about {
        font-size: 1.2em;
        .time {
          font-size: 0.84em;
        }
      }
    }
  }
}

@media screen and (max-width: 978px) {
  .second-Bar {
    margin: 1rem 0;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(4, 1fr);
    grid-template-areas:
      "card-1 card-1 card-2 card-2 card-2"
      "card-1 card-1 card-3 card-3 card-3"
      "card-4 card-4 card-4 card-6 card-6"
      "card-5 card-5 card-5 card-6 card-6"
      "card-7 card-7 card-7 card-7 card-7";
    grid-column-gap: 4em;
    grid-row-gap: 2em;
    .card {
      .about {
        font-size: 1.145em;
        .time {
          font-size: 0.858em;
        }
      }
      .image-block {
        .category {
          text-transform: uppercase;
          font-size: 0.93em;
        }
        .image {
          padding-bottom: 66%;
        }
      }
      &:nth-child(1),
      &:nth-child(6) {
        align-self: start;
        .about {
          text-align: start;
          justify-content: inherit;
        }
      }
      &:nth-child(2),
      &:nth-child(3) {
        flex-direction: inherit;
        .about {
          width: 100%;
          padding: 0.5% 1%;
          .time {
            padding: 0;
          }
        }
      }
      &:nth-child(4),
      &:nth-child(5) {
        flex-direction: row-reverse;
        .about {
          width: 100%;
          text-align: end;
          padding: 0.3rem 0.5rem;
          .text {
            padding: 0;
          }
        }
      }
      &:nth-child(7) {
        width: 90%;
        justify-self: center;
        .about {
          text-align: center;
          padding: 1% 8%;
        }
      }
    }
  }
}
@media screen and (max-width: 775px) {
  .second-Bar {
    // margin-top: 4.5rem;
    // grid-column-gap: 5em;
    .card {
      .about {
        font-size: 1.1em;
        .text {
          line-height: 1.2;
        }
      }
      &:nth-child(1),
      &:nth-child(6) {
        .about {
          text-align: start;
          .text {
            --snup: 5;
          }
        }
      }
      &:nth-child(2),
      &:nth-child(3) {
        flex-direction: inherit;
        .about {
          width: 100%;
          padding: 0.5% 1%;
          .time {
            padding: 0;
          }
        }
      }
      &:nth-child(4),
      &:nth-child(5) {
        flex-direction: row-reverse;
        .about {
          width: 100%;
          text-align: end;
          padding: 0.3rem 0.5rem;
          .text {
            padding: 0;
          }
        }
      }
      &:nth-child(7) {
        width: 90%;
        justify-self: center;
        .about {
          text-align: center;
          padding: 1% 8%;
        }
      }
    }
  }
}
@media screen and (max-width: 475px) {
  .second-Bar {
    margin: 0.5rem 0;
    width: 100% !important;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(7, auto);
    grid-template-areas:
      "card-1 card-2"
      "card-1 card-2"
      "card-3 card-3"
      "card-4 card-4"
      "card-5 card-5"
      "card-6 card-7"
      "card-6 card-7";
    grid-column-gap: 0em;
    grid-row-gap: 2em;
    .card {
      margin: 0 10px;
      flex-direction: column !important;
      align-self: inherit !important;
      // width: 100% !important;
      .about {
        width: auto;
        text-align: start !important;
        padding: 3% 0 0 0 !important;
        font-size: 0.9em;

        .text {
          --snup: 4 !important;
        }
        .time {
          padding-top: 4% !important;
          font-size: 0.88em;
        }
      }
      .image-block {
        flex: 0 0 35%;
        .category {
          font-size: 0.72em;
        }
      }
      &:nth-child(1),
      &:nth-child(2) {
        align-self: start !important;
        .about {
          .text {
            --snup: 3 !important;
          }
        }
      }
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        flex-direction: inherit !important;
        .about {
          padding: 0.5% 0 0 2% !important;
        }
      }
      &:nth-child(6),
      &:nth-child(7) {
        width: 100% !important;
        padding: 0 10px !important;
        margin: 0;
         .image-block {
           flex: 0;
         }
        .about {
          .text {
            --snup: 3 !important;
          }
        }
      }
    }
  }
}
</style>
